import { render, staticRenderFns } from "./DemandCard.vue?vue&type=template&id=19585f8f&scoped=true"
import script from "./DemandCard.vue?vue&type=script&lang=js"
export * from "./DemandCard.vue?vue&type=script&lang=js"
import style0 from "./DemandCard.vue?vue&type=style&index=0&id=19585f8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19585f8f",
  null
  
)

export default component.exports